
import {Component, Inject} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatRadioModule} from '@angular/material/radio';
import {TranslateModule} from '@ngx-translate/core';
import {NgxHekaDesignLibModule, UserDomainSummaryDTO} from 'ngx-heka-design-lib';

export class MultiDomainLeaveResult {
  domain: UserDomainSummaryDTO;
  selectedDomain?: UserDomainSummaryDTO;

  constructor(domain: UserDomainSummaryDTO, selectedDomain?: UserDomainSummaryDTO) {
    this.domain = domain;
    this.selectedDomain = selectedDomain;
  }
}

@Component({
  selector: 'app-multi-domain-leave-dialog',
  imports: [
    FormsModule,
    NgxHekaDesignLibModule,
    MatButtonModule,
    MatDialogModule,
    MatRadioModule,
    TranslateModule
],
  templateUrl: './multi-domain-leave-dialog.component.html',
  standalone: true,
  styleUrl: './multi-domain-leave-dialog.component.scss'
})
export class MultiDomainLeaveDialogComponent {
  domainToLeave?: UserDomainSummaryDTO;
  availableDomains: UserDomainSummaryDTO[] = [];
  selectedDomainId?: string;

  constructor(
    private dialogRef: MatDialogRef<MultiDomainLeaveDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { domainToLeave: UserDomainSummaryDTO; availableDomains: UserDomainSummaryDTO[] }
  ) {
    if (data?.domainToLeave) {
      this.domainToLeave = data.domainToLeave;
    }
    if (data?.availableDomains?.length > 0) {
      this.availableDomains = data.availableDomains;

      if (this.availableDomains.length === 1) {
        this.selectedDomainId = this.availableDomains[0].domainId;
      }
    }
  }

  onLeaveDomain() {
    const selectedDomain = this.availableDomains?.find(d => d.domainId == this.selectedDomainId);
    if (this.domainToLeave) {
      const result = new MultiDomainLeaveResult(this.domainToLeave, selectedDomain);
      this.dialogRef.close(result);
    }
  }
}
